import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'topicNameByCode',
  standalone: true
})
export class TopicNameByCodePipe implements PipeTransform {
  public transform(v: string): string {
    switch (v) {
      case 'payment_terms': {
        return 'Podatki i opłaty za odpady';
      }
      case 'news': {
        return 'Powiadomienia o aktualnościach';
      }
      case 'event': {
        return 'Powiadomienia o wydarzeniach';
      }
      case 'waste': {
        return 'Powiadomienia o wywozie odpadów komunalnych';
      }
      default: {
        return v;
      }
    }
  }
}
